'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _jockey = require('@souche-f2e/jockey');

var _jockey2 = _interopRequireDefault(_jockey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Promise = require('es6-promise').Promise;

// 更多设置
module.exports = {
	/**
  * @desc 调起更多页面
  * @param {Function} cb 点击之后页面带的回调
  *      回调数据:  回调是啥还不知道
  */
	showMorePage: function showMorePage() {
		return new Promise(function (resolve) {
			_jockey2.default.send("H5MoreBridge", {}, function (res) {
				resolve(res);
			});
		});
	},

	/**
  * @desc 更多页面操作设置
  * @param {Function} 更多按钮的数据
  */
	setMoreData: function setMoreData(data) {
		if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) !== 'object') {
			console.warn('更多页面数据必须是数组');
			return;
		}
		var eventObj = {};
		for (var i = 0; i < data.length; i++) {
			data[i].id = i;
			eventObj[i] = data[i].event;
			delete data[i].event;
		}
		_jockey2.default.on("moreInfoBridge", function (payload, complete) {
			complete({
				items: data
			});
		});
		_jockey2.default.on("moreActionBridge", function (payload, complete) {
			eventObj[+payload] && eventObj[+payload]();
		});
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/@souche-f2e/chunyan-util/~/@souche-f2e/tower/lib/more.js
// module id = 269
// module chunks = 4